import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}
interface State {
  error: Error | null;
}

/**
 * Last line of defence above the whole app. Without it an uncaught render
 * error unmounts the React root and the user is left with a blank white page
 * that looks exactly like «still loading» — the owner's «login stuck» report.
 * Deliberately antd-free and i18n-free: it must render even if those failed.
 */
export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Unhandled render error', error, info.componentStack);
  }

  override render(): ReactNode {
    if (!this.state.error) return this.props.children;
    return (
      <div
        style={{
          fontFamily: 'system-ui, sans-serif',
          padding: '35vh 24px 0',
          textAlign: 'center',
          color: '#333',
        }}
      >
        <div style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>Что-то пошло не так</div>
        <div style={{ color: '#777', marginBottom: 20 }}>
          Приложение столкнулось с ошибкой. Перезагрузите его — данные на сервере не пострадали.
        </div>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            background: '#0e7490',
            color: '#fff',
            border: 0,
            borderRadius: 10,
            padding: '12px 28px',
            fontSize: 16,
          }}
        >
          Перезагрузить
        </button>
      </div>
    );
  }
}
